import React from "react";
import { Helmet } from "react-helmet";
import { SeoMeta } from "../../../carlsberg-headless/types/SeoMeta";
import { DefaultMeta } from "../../../carlsberg-headless/types/DefaultMeta";

export interface SEOMetaProps {
  defaultMeta?: DefaultMeta;
  seoMeta?: SeoMeta;
}

const getRobots = ({
  robotIndexing: noIndex,
  robotFollow: noFollow,
}: SeoMeta): string => {
  const defaultFollow = "nofollow";
  const defaultIndex = "noindex";

  const robotString = [
    ...(noIndex ? [noIndex] : [defaultIndex]),
    ...(noFollow ? [noFollow] : [defaultFollow]),
  ].join(", ");

  return robotString;
};

const getTitle = (defaultMeta?: DefaultMeta, seoMeta?: SeoMeta) => {
  const postfixTitle = defaultMeta?.postfixTitle
    ? ` ${defaultMeta?.postfixTitle}`
    : "";
  const prefixTitle = defaultMeta?.prefixTitle
    ? `${defaultMeta?.prefixTitle} `
    : "";
  const title = seoMeta?.titleTag ?? defaultMeta?.defaultTitle;

  return `${prefixTitle}${title}${postfixTitle}`;
};

const SEOMeta: React.FC<SEOMetaProps> = ({ defaultMeta, seoMeta }) => {
  if (!defaultMeta && !seoMeta) return null;

  return (
    <Helmet
      htmlAttributes={{
        lang: defaultMeta?.currentCulture,
      }}
    >
      <meta name="robots" content={getRobots(seoMeta as SeoMeta)} />
      <title>{getTitle(defaultMeta, seoMeta)}</title>
      {seoMeta?.metaDescription && (
        <meta name="description" content={seoMeta?.metaDescription ?? ""} />
      )}
    </Helmet>
  );
};

export { SEOMeta };
